import React from "react"
import useStyles from "./styles"
import { Slide, Paper } from "@material-ui/core"
import plusSquareIcon from "../../assets/plus-square-icon.svg"
import iosShareIcon from "../../assets/ios-share-icon.svg"
import CancelIcon from "@material-ui/icons/Cancel"
import OutsideClickHandler from "react-outside-click-handler"

const InstallMessage = ({ open, onClick }) => {
  const classes = useStyles()
  return (
    <OutsideClickHandler disabled={!open} onOutsideClick={onClick}>
      <Slide in={open} direction="up">
        <Paper className={classes.installMessage} onClick={onClick}>
          <CancelIcon className={classes.closeIcon} />
          <img
            src={plusSquareIcon}
            className={classes.plusIcon}
            alt="Add to Home Screen"
          />
          <div className={classes.text}>
            Install this app on your iPhone for easy access. Tap{" "}
            <img src={iosShareIcon} className={classes.shareIcon} alt="Share" />{" "}
            then 'Add to Home Screen'
          </div>
        </Paper>
      </Slide>
    </OutsideClickHandler>
  )
}

export default InstallMessage



// WEBPACK FOOTER //
// ./src/components/InstallMessage/index.jsx